import React, { useContext, useEffect, useState } from 'react';
import "../Styles/forgetpassword.css"
import Typography from '@mui/material/Typography';
import NextButton from "../Shared/NextButton";
import ForgetPasswordLink from './ForgetPasswordLink';
import useSendLink from '../hook/UseSendLink';
import "../Styles/style.css"
import { Card } from '@mui/material';
import consts from '../Utilities/appConsts.json';
import { useNavigate } from 'react-router-dom';
import {LanguageContext} from '../language/LanguageContext';
import useIframeParams from '../hook/useIframeParam';


const ForgetPasswordPage = () => {
    const { getTranslation } = useContext(LanguageContext);
    const [mail, setMail] = useState("");
    const { sendLink, reminder, textLink, isSendLink, isMail, isShowHelperText,setIsShowHelperText,setIsAddActiveModal, isAddActiveModal,loading,LoaderComponent } = useSendLink();
    const navigate = useNavigate();
    const channel = useIframeParams('channel') || "";
    const temptoken = useIframeParams('temptoken') || "";

    const handleSendLink = async (mail: string) => {
        await sendLink(mail);
    };

    return (
    <Card className="card card-login">
        <div className='display-fp'>
            <LoaderComponent loading={true}>
            </LoaderComponent>
            <Typography component="h1" className='typography-fp'>{getTranslation(consts.HELP_WHEN_YOU_FORGET_PASSWORD)}</Typography>
            {
                isSendLink ? (
                    <>
                        <Typography className='typography-sm-fp'>
                            {textLink}
                        </Typography>
                        <button
                            type="button"
                            onClick={()=>{navigate(`${consts.LOGIN_REGIRSTRA_PAGE}?channel=${channel}&temptoken=${temptoken}`)}}
                            className='typography-sm-fp-link typography-sm-fp-link-button'
                        >
                            {getTranslation(consts.BACK_TO_HOME_PAGE)}
                        </button>
                    </>
                ) : isMail ? (
                    // Render ForgetPasswordLink component when isMail is true
                    <ForgetPasswordLink mail={mail} setMail={setMail} setIsShowHelperText={setIsShowHelperText} setIsAddActiveModal={setIsAddActiveModal} isAddActiveModal={isAddActiveModal} isShowHelperText={isShowHelperText} sendLink={handleSendLink} />
                ) : (
                    <>
                        <Typography className='typography-sm-fp'>
                            {getTranslation(consts.SEND_LINK_TO_MAIL_OR_PHONE)}
                        </Typography>
                        <NextButton
                            handleOnClick={() => reminder(consts.EMAIL, mail)}
                            class='btn-fp-mail'
                            text={getTranslation(consts.SEND_LINK_TO_MAIL)}
                        />
                        <NextButton
                            handleOnClick={() => reminder(consts.MOBILE, mail)}
                            class='btn-fp-phone'
                            text={getTranslation(consts.SEND_LINK_TO_PHONE)}
                        />
                    </>
                )
            }

        </div>  
    </Card>
    );
}
export default ForgetPasswordPage;
